import {chainWalk, deepCopyObject} from "../../../util/Util";

export const updateConfigurationsInZancaSortAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes.testConfig =
        chainWalk(() => JSON.stringify(configurations.testConfig), "[]")
    updatedAsset.assetDetails.assetAttributes.locationConfig =
        chainWalk(() => JSON.stringify(configurations.locationConfig), "[]")
    updatedAsset.assetDetails.assetAttributes.tierConfig =
        chainWalk(() => {
            const tierConfigObj = {};
            (configurations.tierConfig || []).forEach(tier => {
                tierConfigObj[tier.tierName] = {
                    capacity: tier.capacity,
                    levels: `${tier.startLevel}:${tier.endLevel}`
                };
            });
            return JSON.stringify(tierConfigObj);
        }, "{}")
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/datamodel/ZancaSortAssetModelResource.js